<template>
    <div>
        <v-select :multiple="false" :options="optionsCadenas" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedCadenas" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "cadenas",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedCadenas:[],
            optionsCadenas:[]
        }
    },
    mounted() {
        this.getGestores();
    },
    methods:{
        getGestores(){ let $this = this;
            axios
                .post('/api/AdminCatalogos/cadenasMain')
                .then(function (r){
                    $this.optionsCadenas = r.data;
                });
        },
        setCambio(){
            this.$emit('cambioCadena');
        }

    }
}
</script>

<style scoped>

</style>
